import { render } from "./PriceCategories.vue?vue&type=template&id=92b5bc54"
import script from "./PriceCategories.vue?vue&type=script&lang=js"
export * from "./PriceCategories.vue?vue&type=script&lang=js"

import "./PriceCategories.vue?vue&type=style&index=0&id=92b5bc54&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__